import React, {useEffect, useState} from 'react';
import {PasswordSource} from '@store/password/PasswordSource';
import {browserHistory} from 'react-router';
import {PasswordResetForm} from '@components/password/PasswordResetForm';

interface PasswordResetContainerProps {
  routeParams: {code: string} | undefined;
}

export const PasswordResetContainer: React.FC<PasswordResetContainerProps> = ({routeParams}) => {
  const code = routeParams && routeParams['code'];

  // Code failed validation.
  const [badCode, setBadCode] = useState<boolean>(false);
  // Unexpected code validation error.
  const [error, setError] = useState<boolean>(false);

  // Validate the code. This will tell us if it is bad.
  useEffect(() => {
    if (code) {
      PasswordSource.validateResetCode(code).catch(e => {
        if (e.response.status === 404) {
          setBadCode(true);
        } else {
          console.error('Unexpected error', e);
          setError(true);
        }
      });
    }
  }, [code]);

  // If the code is bad, go to the expired page.
  useEffect(() => {
    if (badCode) {
      // redirect to expired link page
      browserHistory.push('/expired/link');
    }
  }, [badCode]);

  // Otherwise, render the page.
  if (error) {
    return <div>There was an error processing your request. Please try again later.</div>;
  }

  if (code) {
    return <PasswordResetForm code={code} />;
  }
  return null; // router config requires a code, so this shouldn't happen.
};
